import React from 'react';
import { useIntl } from 'react-intl';

import EnterLayout from '../../components/layout/EnterLayout';
import Alert from '../../components/common/Alert';

const RedeemSuccess = () => {
  const intl = useIntl();

  return (
    <EnterLayout verticalPaddings={[70, 50]}>
      <Alert
        icon="success"
        title={intl.formatMessage({
          id: 'redeemSuccess.title',
          defaultMessage: 'Your code is successfully applied!',
          description: 'Title informing about applied free premium time promo code',
        })}
        actionTitle={intl.formatMessage({
          id: 'redeemSuccess.toAccount',
          defaultMessage: 'Go to Account',
          description: 'Link to main user profile page',
        })}
        href="/profile"
      />
    </EnterLayout>
  );
};

export default RedeemSuccess;
